// extracted by mini-css-extract-plugin
export default {"app":"app_app__VBlLf","appInnerwrapper":"app_appInnerwrapper__cfLRY","lottieWrapper":"app_lottieWrapper__th21r"};